import { UnstyledButton } from "src/ui";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import { localize } from "src/l10n";
import { useRef, useState } from "react";
import "./ComposerAttachmentVideo.scss";

interface IProps {
    attachment: Spintr.IChatMessageAttachment;
    onRemove: () => void;
    onUpdate: (attachment: Spintr.IChatMessageAttachment) => void;
}

const ComposerAttachmentVideo = (props: IProps) => {
    const canvasRef = useRef<HTMLCanvasElement>();
    const [imageUrl, setImageUrl] = useState<string>("");
    const [error, setError] = useState<boolean>(false);

    const blob = URL.createObjectURL(props.attachment.data);

    const onLoadedMetadata = (event: React.SyntheticEvent<HTMLVideoElement>) => {
        const videoPlayer = event.target as HTMLVideoElement;

        const duration = videoPlayer.duration;

        setTimeout(() => {
            videoPlayer.currentTime = duration / 2;
        }, 200);
    };

    const onSeeked = (event: React.SyntheticEvent<HTMLVideoElement>) => {
        const videoPlayer = event.target as HTMLVideoElement;

        const canvas = canvasRef?.current ? canvasRef.current : videoPlayer.parentElement.querySelector("canvas");
        if (!canvas) {
            return;
        }

        canvas.width = videoPlayer.videoWidth;
        canvas.height = videoPlayer.videoHeight;

        const context = canvas.getContext("2d");
        context.drawImage(videoPlayer, 0, 0, canvas.width, canvas.height);

        const dataUrl = context.canvas.toDataURL("image/jpeg", 0.75);

        setImageUrl(dataUrl);
    };

    const onError = () => {
        setError(true);
    };

    return (
        <div className="ComposerAttachmentVideo">
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            <video
                autoPlay={false}
                controls={false}
                onLoadedMetadata={onLoadedMetadata}
                onSeeked={onSeeked}
                onError={onError}
                src={blob}
            />
            <canvas ref={canvasRef} />
            {imageUrl && <img src={imageUrl} alt={localize("ATTACHED_VIDEO")} />}
            {error && (
                <div className="error">
                    <Visage2Icon icon="video" />
                </div>
            )}

            {(imageUrl || error) && (
                <UnstyledButton
                    className="close-button visage-box-shadow"
                    onClick={props.onRemove}
                    title={localize("TaBort")}
                >
                    <Visage2Icon icon="close-circle" />
                </UnstyledButton>
            )}
        </div>
    );
};

export default ComposerAttachmentVideo;
